/* eslint-disable import/no-unresolved */
import { useEffect } from 'preact/hooks'
import { connect } from 'react-redux'
import { Router } from 'preact-router'
import { withGTM } from 'react-tag-manager'
import ReactGA from 'react-ga'

import auth from 'libs/auth'
import Account from 'routes/account'
import Auth from 'routes/auth'
import ChannelPreviews from 'routes/channel-previews'
import CheckoutApp from 'routes/checkout-app'
import DvrApp from 'routes/dvr-app'
import ExternalUrl from 'routes/external-url'
import Live from 'routes/live'
import Search from 'routes/search'
import Settings from 'routes/settings'
import SupportApp from 'routes/support-app'
import VideoLibraryApp from 'routes/video-library-app'
import YouTube from 'routes/youtube'
import Paywall from 'components/paywall/paywall'
import Confirmation from 'components/register/Confirmation'
import ForgotPassword from 'components/forgot-password'
import { getAccountGA } from 'selectors/app'
import styles from 'components/app/default-app.css'

const AppRouting = ({ GTM, accountGA, defaultRoute = '' }) => {
  useEffect(() => ReactGA.initialize(accountGA), [])

  const handleRoute = e => {
    if (GTM.api) {
      const data = {
        event: 'pageview',
        url: e.url,
      }
      if (auth.isLoggedIn()) {
        data['userId'] = auth.getUsername()
      }
      GTM.api.trigger(data)
    }
  }

  const getRouteProps = routeName => {
    if (defaultRoute === routeName) {
      return {
        default: true,
      }
    } else {
      return true
    }
  }

  return (
    <div className={styles['app-routing']}>
      <Router onChange={handleRoute}>
        <ChannelPreviews
          path={`${__webpack_public_path__ || '/'}previews`}
          {...getRouteProps('previews')}
        />
        <Account path={`${__webpack_public_path__ || '/'}account/:tab`} />
        <Account
          path={`${__webpack_public_path__ || '/'}account/`}
          {...getRouteProps('account')}
        />
        <Auth path={`${__webpack_public_path__ || '/'}auth/:action`} />
        <ForgotPassword path={`${__webpack_public_path__ || '/'}restore`} />
        <CheckoutApp
          path={`${__webpack_public_path__ || '/'}checkout/:action?`}
          {...getRouteProps('checkout')}
        />
        <DvrApp
          path={`${__webpack_public_path__ || '/'}dvr/:action?/:id?`}
          {...getRouteProps('dvr-library')}
        />
        <Live path={`${__webpack_public_path__ || '/'}live`} {...getRouteProps('live')} />
        <Paywall
          path={`${__webpack_public_path__ || '/'}paywall/:id/:isGuide?`}
          {...getRouteProps('paywall')}
        />
        <VideoLibraryApp
          path={`${__webpack_public_path__ || '/'}video-library`}
          {...getRouteProps('video-library')}
        />
        <VideoLibraryApp
          path={`${__webpack_public_path__ || '/'}video-category/:categoryId`}
        />
        <VideoLibraryApp
          path={`${__webpack_public_path__ || '/'}video/:action/:videoId`}
        />
        <SupportApp
          path={`${__webpack_public_path__ || '/'}support/:action?/:action1?/:action2?`}
          {...getRouteProps('support')}
        />
        <Search
          path={`${__webpack_public_path__ || '/'}search`}
          {...getRouteProps('search')}
        />
        <YouTube path={`${__webpack_public_path__ || '/'}youtube/:section?/:id?`} />
        <Settings
          path={`${__webpack_public_path__ || '/'}settings/:action?`}
          {...getRouteProps('settings')}
        />
        <ExternalUrl
          path={`${__webpack_public_path__ || '/'}external/:itemId`}
          {...getRouteProps('external-url')}
        />
        <Confirmation
          path={`${__webpack_public_path__ || '/'}register/confirmation`}
          {...getRouteProps('register-confirmation')}
        />
      </Router>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    accountGA: getAccountGA(state),
  }
}

export default withGTM(connect(mapStateToProps)(AppRouting))
